import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, Modal, ModalHandle, inject } from 'Mri.Web.Common';
import * as React from 'react';
import { Button } from 'reactstrap';
import { DisplaysStore } from '../Displays/DisplaysStore';
import { ManifestsStore } from './ManifestsStore';

export interface ILinkedManifestModal {
    readonly displaySerial: string;
    readonly modalHandle: ModalHandle;
    readonly softwareUpdateManifestGuid?: string;
}

@autoinject
@observer
export class LinkedManifestModal extends React.Component<ILinkedManifestModal> {
    public render() {
        const { displaySerial } = this.props;
        return (
            <Modal
                title={`${displaySerial} Active Linked Manifests`}
                modalHandle={this.props.modalHandle}
                className="p-0"
            >
                <ul>
                    {this.displayUpdateStatus?.linkedSoftwareUpdateManifests?.map(
                        linkedSoftwareUpdateManifest =>
                            linkedSoftwareUpdateManifest.manifestGuid != this.props.softwareUpdateManifestGuid && (
                                <li key={linkedSoftwareUpdateManifest.manifestGuid}>
                                    <a
                                        href={`/software-updates/manifests/${linkedSoftwareUpdateManifest.manifestGuid}/status`}
                                        target="_blank"
                                    >
                                        <Button color="link">{linkedSoftwareUpdateManifest.manifestName}</Button>
                                    </a>
                                </li>
                            )
                    )}
                </ul>
            </Modal>
        );
    }

    @computed
    private get displayUpdateStatus() {
        return this.displaysStore.updateStatuses.get(this.props.displaySerial);
    }

    @inject
    private readonly displaysStore!: DisplaysStore;
    @inject
    private manifestsStore!: ManifestsStore;
}
